import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import clsx from 'clsx';
import { forwardRef, useCallback, useEffect, useImperativeHandle, useRef, useState } from 'react';
import TrashIcon from '../../fundamentals/icons/trash-icon';
import Spinner from '../spinner';
import Tooltip from '../tooltip';
const TwoStepDelete = forwardRef(({ onDelete, deleting = false, children, className }, ref) => {
    const [armed, setArmed] = useState(false);
    const innerRef = useRef(null);
    useImperativeHandle(ref, () => innerRef.current);
    const handleTwoStepDelete = () => {
        if (!armed) {
            setArmed(true);
            return;
        }
        onDelete();
        setArmed(false);
    };
    const disarmOnClickOutside = useCallback((e) => {
        if (innerRef.current && !innerRef.current.contains(e.target)) {
            if (armed) {
                setArmed(false);
            }
        }
    }, [armed]);
    useEffect(() => {
        document.addEventListener('mousedown', disarmOnClickOutside);
        return () => {
            document.removeEventListener('mousedown', disarmOnClickOutside);
        };
    }, [disarmOnClickOutside]);
    return (_jsxs("button", { className: clsx('flex items-center justify-center rounded-lg border transition-all', {
            'border-rose-50 bg-rose-50 px-3 py-1.5': armed,
            'border-gray-20 bg-transparent p-1.5': !armed,
        }, {
            '!bg-grey-40 !border-grey-40 !p-1.5': deleting,
        }, className), disabled: deleting, onClick: handleTwoStepDelete, ref: innerRef, children: [_jsx("div", { className: clsx('inter-small-semibold text-rose-50', {
                    hidden: armed || deleting,
                }), children: children || _jsx(TrashIcon, { className: "text-grey-50", size: 20 }) }), _jsx("span", { className: clsx('inter-small-semibold text-white', {
                    hidden: !armed || deleting,
                }), children: _jsx(Tooltip, { content: "Are you sure?", side: "top", sideOffset: 16, open: armed, children: "Confirm" }) }), _jsx("span", { className: clsx('flex items-center justify-center', {
                    hidden: !deleting,
                }), children: _jsx(Spinner, { size: "medium" }) })] }));
});
export default TwoStepDelete;
//# sourceMappingURL=index.js.map